class WidgetItemValue {
  constructor(private readonly _value: string = "") {
  }

  get value() {
    return this._value;
  }
}

export default WidgetItemValue;
